import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import AWS from 'aws-sdk';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import moment from 'utils/moment';
import Button from '../../../../components/button';
import Loading from '../../../../components/loading';
import styles from '../initiateForm/form.module.scss';
import { GetFileName, S3Uploads } from '../../../services';
import { isLocal, hostName } from '../../../../constants/apiEnv';
import Collapsible from '../../../../components/collapsible/Collapsible';
import CustomFields from '../../../../components/customFields/CustomFields';
import { getThreeLetterCountryCode, getCountryRegion } from '../../../../utils/helpers';
import ReqAttachments from '../Components/ReqAttachments';
import { SaveAlert } from '../../components/ActionCompo';
import { handleSignature, valueType } from '../../components/PermitData';

const AdpDriverPublicForm = (props) => {
  const { changePage, match: { params: { installationId, airportCode } }, translation, countrycode, selectedCategory,
  isPaymentAvailable } = props;

  const url = hostName.slice(6);
  const publicUrl = isLocal ? process.env.REACT_APP_BACKEND_PUBLICHOST : `https://apis.${getCountryRegion(installationId)}${url}/public`;
  const OTP = useSelector(state => state?.permitManagement?.otp);
  const userProfile = useSelector(state => state?.permitManagement?.userData);
  const params = useSelector(state => state?.permitManagement?.airportSettings);
  const adpCategories = useSelector(state => state?.permitManagement?.userData?.adp_categories);
  const existAnswers = useSelector(state => state?.permitManagement?.userData?.permit);
  const ordering = useSelector(state => state?.permitManagement?.userData?.form?.schema?.ordering);
  const customFields = useSelector(state => state?.permitManagement?.userData?.form?.schema?.fields);
  const notes = useSelector(state => state?.permitManagement?.userData?.form?.default_fields?.notes);
  const defaultFields = useSelector(state => state?.permitManagement?.userData?.form?.default_fields?.default_field);
  const reqAttach = useSelector(state => state?.permitManagement?.userData?.form?.default_fields?.required_attachements);

  const [alert, setAlert] = useState(false);
  const [load, setLoad] = useState(false);
  const [state, setState] = useState({
    answers: {
      ...existAnswers
    },
    loader: false,
    dateError: false,
    formErrors: false
  });
  const [errors, setErrors] = useState({});
  const [reqErrors, setReqErrors] = useState({});
  const [temp, setTemp] = useState(true);
  const [allFields, setAllFields] = useState([]);
  const [countryState, setcountryState] = useState([]);
  const [mergedFields, setMergedFields] = useState([]);
  const [disableSign, setDisableSign] = useState(false);
  const [conditionalFields, setConditionalFields] = useState({});


  // fixed fields - Attachments, Profile and Signature
  const staticFields = [
    {
      conditional: false,
      default: false,
      description: '',
      enable_ocr: false,
      full_width: false,
      id: 'attachments',
      internal: true,
      list_view: false,
      lock: false,
      required: true,
      search_enable: false,
      source_fields: [],
      system_generated: false,
      title: 'Attachments',
      type: 'attachments'
    },
    {
      conditional: false,
      default: false,
      description: '',
      enable_ocr: false,
      full_width: false,
      id: 'photo',
      internal: true,
      list_view: false,
      lock: false,
      required: true,
      search_enable: false,
      source_fields: [],
      isCrop: true,
      system_generated: false,
      title: 'Profile Picture',
      type: 'attachments'
    },
    {
      conditional: false,
      default: false,
      description: '',
      enable_ocr: false,
      full_width: true,
      id: 'signature',
      isDisabled: disableSign,
      internal: true,
      list_view: false,
      lock: false,
      required: true,
      search_enable: false,
      source_fields: [],
      system_generated: false,
      title: 'Signature',
      type: 'signature'
    }
  ];

  // used for differentiate the default and custom fields
  const defaultIDs = [
    'first_name', 'last_name', 'email', 'phone', 'designation', 'dob', 'company',
    'lic_issue_date', 'lic_exp_date', 'permit_type', 'category_of_adp', 'signature',
    'driving_lic_num', 'type_of_lic', 'issusing_authority', 'employee_id'
  ];

  useEffect(() => {
    if (defaultFields && customFields) {
      const combinedFields = [...defaultFields, ...customFields];
      let Fields;
      let condFields = {};
      let fieldErros = { ...errors,
        signature: state.answers.signature ? !Object.keys(state.answers?.signature) : true,
        attachments: reqAttach?.length > 0 ? false : !state.answers?.attachments?.length > 0
      };
      const filteredFields = combinedFields?.filter(field => field?.id !== 'signature' && !field?.isDisabled);
      if (ordering && ordering?.length) { // sorted - if ordering
        Fields = ordering
          .map(orderId => filteredFields.find(field => field.id === orderId))
          .filter(field => field); // Remove undefined entries if any
      } else {
        Fields = filteredFields; // without sorted - if no ordering
      }
      setMergedFields(Fields);
      Fields.forEach((ele) => {
        if (ele.conditional) { // check the conditional fields
          if (condFields[ele.conditional_field.key]) {
            condFields[ele?.conditional_field?.key] = [...condFields[ele?.conditional_field?.key], ele];
          } else {
            condFields[ele?.conditional_field?.key] = [ele];
          }
        } else if (ele.required) {
          if (defaultIDs.includes(ele.id)) {
            if (ele.id === 'category_of_adp') {
              fieldErros = { ...fieldErros, [ele.id]: selectedCategory ? false : (!state.answers[ele.id]) };
            } else {
              fieldErros = { ...fieldErros, [ele.id]: (!state.answers[ele.id]) };
            }
          } else if (ele.id === 'designation') {
            fieldErros = { ...fieldErros, [ele.id]: !state.answers.designation };
          } else {
            fieldErros = { ...fieldErros, [ele.id]: (!state.answers.response?.[ele.id]) };
          }
        }
      });
      setDisableSign(combinedFields?.some(ele => ele.id === 'signature' && ele?.isDisabled === true));
      setConditionalFields(condFields);
      setErrors(fieldErros);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultFields]);

  // set the country states to issuing_authority field
  useEffect(() => {
    const setIssuingAuthorityOptions = (allStates) => {
      const all = mergedFields?.map((ele) => {
        if (ele.id === 'issusing_authority') {
          return {
            ...ele,
            values: allStates?.map(each => ({
              key: each?.state,
              value: each?.state
            })),
            default_value: {}
          };
        }
        return ele;
      });
      setAllFields(all);
    };
    if (mergedFields && countryState) {
      setIssuingAuthorityOptions(countryState);
    }
  }, [mergedFields, countryState]);

  useEffect(() => {
    let reqFieldError = {};
    if (reqAttach?.length > 0) {
      reqAttach.forEach((e) => {
        let name = e;
        if (typeof e === 'object') {
          name = e.attachmentName;
        }
        reqFieldError = {
          ...reqFieldError,
          [`${name}_attachments`]: (!state.answers?.req_attachments?.[`${name}_attachments`]?.length > 0)
        };
      });
      setReqErrors(reqFieldError);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.answers?.req_attachments, reqAttach]);

  // getting the country states from current region
  useEffect(() => {
    if (defaultFields?.length) {
      const getConfig = () => {
        AWS.config.update({
          region: process.env.REACT_APP_REGION
        });
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({
          IdentityPoolId: process.env.REACT_APP_IDENTITY_POOL_ID
        });
        return AWS.config.credentials.getPromise();
      };
      getConfig();

      const docClient = new AWS.DynamoDB.DocumentClient({ region: process.env.REACT_APP_REGION });
      const threeCharCode = getThreeLetterCountryCode(countrycode);
      const param = {
        TableName: 'aeros_countries_states',
        KeyConditionExpression: 'country_large_code = :country_large_code',
        ExpressionAttributeValues: {
          ':country_large_code': threeCharCode
        }
      };
      docClient.query(param).promise().then((res) => {
        setcountryState(res.Items);
      });
    }
  }, [defaultFields, installationId, countrycode]);

  // set the existing/saved answers into state
  useEffect(() => {
    if (temp && existAnswers) {
      let filterAnswer = {};
      Object.keys(existAnswers).forEach((item) => {
        if (existAnswers[item] !== null) {
          filterAnswer[item] = existAnswers[item];
        }
      });
      const all_attachments = existAnswers?.attachments.reduce((acc, obj) => ({ ...acc, [obj.attachment_id]: obj }), {});
      const requireAttachments = existAnswers?.req_attachments
        && Object.keys(existAnswers?.req_attachments)
        .reduce((acc, key) => ({ ...acc, [key]: existAnswers?.req_attachments[key].map(att => all_attachments[att]) }), {});
      setState({
        ...state,
        answers: {
          ...filterAnswer,
          category_of_adp: existAnswers.category_of_adp
            ? existAnswers.category_of_adp
            : (selectedCategory || null),
          req_attachments: requireAttachments
        }
      });
      setTemp(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [temp, existAnswers, state]);

  const getValue = (item) => {
    const idExistsInDefault = defaultIDs.includes(item.id);
    const answer = idExistsInDefault ? state.answers[item?.id] : state.answers.response?.[item?.id];
    return !answer;
  };

  const getDefAnswer = (item) => {
    if (state.answers[item.id]) {
      return state.answers[item.id];
    }
    return valueType(item)?.value;
  };

  const getCusAns = (item) => {
    if (state.answers.response?.[item.id]) {
      return state.answers.response?.[item.id];
    }
    return valueType(item)?.value;
  };

  const handleAnswerChanged = (section, answer, fieldId) => {
    if (conditionalFields?.[fieldId]) { // check the conditional fields
      conditionalFields[fieldId].forEach((item) => {
        const conditionValues = item?.conditional_values;
        const fieldValue = answer;
        const enableCondition = conditionValues.some(value => fieldValue === value?.value);
        const defaultValue = valueType(item)?.value;
        if (item.required) {
          handleFieldErrorChanged(
            item.id,
            enableCondition ? getValue(item) : false
          );
        }
        if (enableCondition) {
          setState(prev => ({
            answers: {
              ...prev.answers,
              ...(defaultIDs.includes(item.id)
                ? { [item.id]: getDefAnswer(item) }
                : { response: { ...prev.answers.response, [item.id]: getCusAns(item) } }
              )
            }
          }));
        } else {
          setState(prev => ({
            answers: {
              ...prev.answers,
              ...(defaultIDs.includes(item.id)
                ? { [item.id]: defaultValue }
                : { response: { ...prev.answers.response, [item.id]: defaultValue } }
              )
            }
          }));
        }
      });
    }
    if (section === 'response') { // check custom field answers
      setState(prevState => ({
        ...prevState,
        answers: {
          ...prevState.answers,
          response: {
            ...prevState.answers.response,
            [fieldId]: answer
          }
        }
      }));
    } else if (section === 'req_attachments') { // check required attachment answers
      setState(prevState => ({
        ...prevState,
        answers: {
          ...prevState.answers,
          req_attachments: {
            ...prevState.answers.req_attachments,
            [fieldId]: answer
          }
        }
      }));
    } else if (section === 'req_attachments_dates') {
      setState(prevState => ({
        ...prevState,
        answers: {
          ...prevState.answers,
          req_attachments_details: {
            ...prevState.answers.req_attachments_details,
            [section]: {
              ...prevState.answers.req_attachments_details?.[section],
              [fieldId]: answer
            }
          }
        }
      }));
    } else { // check default field answers
      setState(prevState => ({
        ...prevState,
        [section]: {
          ...prevState[section],
          [fieldId]: answer
        }
      }));
    }
  };

  const handleFieldErrorChanged = (id, value) => {
    setErrors(prevErrors => ({ ...prevErrors, [id]: value }));
  };

  const getRequired = (data, isFieldError) => {
    let requiredKeys = { // static fields for required
      signature: state.answers.signature ? !Object.keys(state.answers?.signature) : true,
      attachments: reqAttach?.length > 0 ? false : !state.answers?.attachments?.length > 0
    };
    let FieldError = { ...errors };
    if (data?.length !== 0) {
      data.forEach((ele) => {
        if (ele.required) { // checking required fields
          if (defaultIDs.includes(ele.id)) { // checking required default fields
            requiredKeys = { ...requiredKeys, [ele.id]: true };
            FieldError = { ...FieldError, [ele.id]: !state.answers[ele.id] };
          } else if (!(defaultIDs.includes(ele.id))) { // checking required fields
            requiredKeys = { ...requiredKeys, [ele.id]: true };
            FieldError = { ...FieldError, [ele.id]: !state.answers.response?.[ele.id] };
          }
        }
      });
    }
    return isFieldError ? FieldError : requiredKeys;
  };

  const handleRemoveAttachments = (attachment) => {
    const filtereAttachments = state.answers.attachments.filter(e => e.attachment_id !== attachment.attachment_id);
    setState({ ...state, answers: { ...state.answers, attachments: filtereAttachments } });
  };

  // ----------- Attachment Upload function start -----------
  const getFileNames = async (count, code) => {
    const response = await GetFileName.getPublicUploadFileName(count, code, 'driver_permit');
    return response;
  };

  const doS3Upload = async (files, fileIds, entity, getErrorAlert) => {
    const response = await S3Uploads.uploadFiles(
      files,
      fileIds.filename,
      entity,
      installationId,
      airportCode,
      getErrorAlert
    );
    return response;
  };

  const handleUploadAttachments = async (attachments, entity) => {
    const attachmentIds = [];
    const newAttachments = [];
    const oldAttachments = [];
    attachments.forEach((e) => {
      if (!e.id) {
        newAttachments.push(e);
      } else if (e.id) {
        oldAttachments.push(e.attachment_id);
      }
    });
    let fileIds = '';
    if (newAttachments.length > 0) {
      fileIds = await getFileNames(newAttachments?.length, airportCode);
    }
    if (fileIds) {
      await doS3Upload(
        newAttachments,
        fileIds,
        entity || 'adp',
        getErrorAlert
      ).then(() => {
        fileIds.filename.forEach((id) => {
          attachmentIds.push(id.toString());
        });
      });
    }
    if (oldAttachments.length > 0) {
      attachmentIds.push(...oldAttachments);
    }
    return attachmentIds;
  };

  const uploadtoS3 = async (attachments) => {
    let fileIds = '';
    fileIds = await getFileNames(attachments.length, airportCode);
    const list = [];
    if (fileIds) {
      await doS3Upload(attachments, fileIds, 'adp')
        .then((res) => {
          res.forEach((ele) => {
            list.push(ele?.id?.toString());
          });
        });
    }
    return list;
  };

  // ----------- Attachment Upload functions end -----------

  const handelSubmit = async (isDraft) => {
    const { attachments, signature, photo, lic_exp_date, lic_issue_date, dob, req_attachments } = state.answers;
    let error = { ...errors,
      first_name: false,
      last_name: false,
      phone: false,
      category_of_adp: !state.answers?.category_of_adp,
      photo: !state.answers?.photo?.length > 0
     };
    let dataObject = {};
    let newDate = moment().startOf('day');

    let noErrors = Object.keys(error).every(k => (
      error[k] === false // || state.answers?.[k] || state.answers.response?.[k] || state.answers.req_attachments?.[k]
    ));
    let noReqErrors = Object.keys(reqErrors).every(k => reqErrors[k] === false);
    let dateOfBirth = moment(dob);
    let age = newDate.diff(dateOfBirth, 'year', true);
    let issueDate = moment(lic_issue_date);
    let expireDate = moment(lic_exp_date);

    if ((lic_issue_date && issueDate.diff(moment(new Date())) > 0) && !isDraft) {
      setState({
        ...state,
        dateError: 'License Issue Date cannot be a future date. Please modify the date and try again.'
      });
    } else if ((lic_exp_date && expireDate.diff(moment(new Date())) < 0) && !isDraft) {
      setState({
        ...state,
        dateError: 'License Expire Date should be a future date. Please modify the date and try again.'
      });
    } else if (lic_exp_date && lic_issue_date && issueDate.diff(expireDate) > 0 && !isDraft) {
      setState({
        ...state,
        dateError: 'License Issued date should not be older than License Expiry date.'
      });
    } else if (dob && ((dob && age <= 17) && !isDraft)) {
      setState({
        ...state,
        dateError: 'Applicant age should be 17 years or above.'
      });
    } else if ((noErrors && noReqErrors) || isDraft) {
      setState({ ...state, loader: true, dateError: '' });

      // for required attachment id's
      const attchList = reqAttach?.length > 0 && Object.entries(req_attachments || {}).reduce((acc, [key, attachment]) => {
        if (Array.isArray(attachment)) {
          acc[key] = attachment
            .map(item => item?.attachment_id)
            .filter(id => typeof id === 'string');
        } else {
          acc[key] = [];
        }
        return acc;
      }, {});

      const attachmentId = (!reqAttach?.length > 0 && attachments?.length > 0)
        ? attachments.map(item => item?.attachment_id).filter(id => typeof id === 'string')
        : [];
      const signatureId = await handleSignature(signature, handleUploadAttachments, uploadtoS3, 'adp');
      const photoId = (photo?.length > 0 && Array.isArray(photo))
        ? photo.map(item => item?.attachment_id).filter(id => typeof id === 'string')
        : [];

      const customSignFields = allFields.filter(field => field.type === 'signature') || [];

      if (customSignFields.length > 0) {
        for (let index = 0; index < customSignFields.length; index++) {
          const customSignField = customSignFields[index]?.id;
          const schemaField = customSignFields[index];
          const customSignValue = Array.isArray(state.answers?.response?.[customSignField])
            ? state.answers?.response?.[customSignField]
            : !!state.answers?.response?.[customSignField] && [state.answers?.response?.[customSignField]];
          if (schemaField?.type === 'signature' && customSignValue?.length > 0) {
            // eslint-disable-next-line no-await-in-loop
            state.answers.response[customSignField] = await handleUploadAttachments(customSignValue, 'adp') || [];
          }
        }
      }

      const attachmentFields = customFields.filter(schemaField => (
        schemaField?.type === 'attachments'
      ));
      if (attachmentFields.length > 0) {
        for (let index = 0; index < attachmentFields.length; index++) {
          const attachmentField = attachmentFields[index]?.id;
          const schemaField = attachmentFields[index];
          if (schemaField?.type === 'attachments' && state.answers?.response?.[attachmentField]?.length > 0) {
            state.answers.response[attachmentField] = state.answers.response[attachmentField]
              .map(item => item?.attachment_id)
              .filter(id => typeof id === 'string');
          }
        }
      }
      const adp_category_id = adpCategories?.find(ele => ele.name === state.answers?.category_of_adp);
      dataObject = {
        ...dataObject,
        ...state.answers,
        photo: photoId,
        attachments: attachmentId,
        req_attachments: attchList,
        signature: signatureId?.[0] || [],
        adp_category: adp_category_id?.id || null,
        dob: dob && state.answers.dob ? moment(state.answers.dob).format('YYYY-MM-DD') : state.answers.dob,
        lic_exp_date: lic_exp_date && (state.answers.lic_exp_date
          ? moment(state.answers.lic_exp_date).format('YYYY-MM-DD')
          : state.answers.lic_exp_date),
        lic_issue_date: lic_issue_date && (state.answers.lic_issue_date
          ? moment(state.answers.lic_issue_date).format('YYYY-MM-DD')
          : state.answers.lic_issue_date)
      };
      let data = { ...dataObject };
      if (photoId?.length) {
        data.attachments.push(...photoId);
      }
      if (Object.keys(req_attachments)?.length > 0) {
        data.attachments.push(...Object.values(attchList).flat());
      }
      if (allFields.length !== 0) {
        let checkbox = allFields.filter(ele => ele.type === 'boolean');
        if (checkbox?.length !== 0) {
          checkbox.forEach((ele) => {
            if (!data.response[ele.id]) {
              data = { ...data, response: { ...data.response, [ele.id]: false } };
            }
          });
        }
      }

      const headers = {
        'Content-Type': 'application/json',
        Authorization: OTP
      };
      const apiName = isDraft ? 'save_driver_permit' : 'submit_dp';
      Axios.post(`${publicUrl}/driver_permit/${apiName}/${params?.id}/${params?.airportCode?.toUpperCase()}`,
        { ...data },
        { headers })
        .then((res) => {
          if (!isDraft) {
            if (res?.data?.status === 11 && (res.data?.calendar_visibility === 'both' || res.data?.calendar_visibility === 'driver')) {
              if (!isPaymentAvailable) {
                changePage('scheduling', 'scheduling');
              } else {
                changePage('payment', 'payment');
              }
            } else {
              changePage('formStatus', 'completed');
            }
          }
          toast.success('Submited Successfully');
          const obj_att = res.data.permit.attachments.reduce((acc, obj) => ({ ...acc, [obj.attachment_id]: obj }), {});
          const final_req = res.data.permit.req_attachments
            && Object.keys(res.data.permit.req_attachments)
              .reduce((acc, key) => ({ ...acc, [key]: res.data.permit.req_attachments[key].map(att => obj_att[att]) }), {});
          setState({ ...state, loader: false, formErrors: false, dateError: false, answers: { ...res.data.permit, req_attachments: final_req } });
        })
        .catch(() => {
          toast.error('Please try again later');
          setState({ ...state, loader: false, dateError: false });
        });
    } else {
      setState({
        ...state,
        formErrors: true,
        dateError: false
      });
      if (lic_exp_date && lic_issue_date && expireDate.diff(issueDate) > 0) {
        setState({
          ...state,
          dateError: false,
          formErrors: true
        });
      }
    }
  };

  const getErrorAlert = value => setAlert(value);

  const getLoadingStatus = value => setLoad(value);

  const getAnswers = fieldId => ( // Helper function to get answers
    defaultIDs.includes(fieldId)
    ? state.answers[fieldId]
    : state.answers.response?.[fieldId]);

  const fieldAnswers = {}; // Build the answers object using a loop
  allFields.forEach((field) => {
    fieldAnswers[field.id] = getAnswers(field.id);
  });

  return (
    <div className={styles.container}>
      <Loading loadingStatus={state.loader || !allFields?.length} />
      {/* Header */}
      <div className={styles.headder}>
        <FormattedMessage
          id=" "
          defaultMessage={`New ${userProfile?.permit_management_nomenclature?.driver_permit || 'ADP'} Application Form`}
        />
      </div>
      <span className={styles.note}>
        <FormattedMessage
          id="application.note"
          defaultMessage="Please note: "
          tagName="b"
        />
        <FormattedMessage
          id=" "
          defaultMessage={`Renewal ${userProfile?.permit_management_nomenclature?.driver_permit || 'ADP'}
            applications should be submitted through the existing application`}
        />
      </span>
      <div className={styles.childContainer}>
        {/* All Default and Custom fields from Schema */}
        <CustomFields
          handleAnswerChanged={(a, b) => (handleAnswerChanged(defaultIDs.includes(b) ? 'answers': 'response', a, b))}
          handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
          handleAttachmentFailedAlert={getErrorAlert}
          handleAutoUploadAttachments={handleUploadAttachments}
          getLoadingStatus={getLoadingStatus}
          selectedCategory={selectedCategory}
          entityName="adp"
          applicationType="New"
          showFormErrors={state.formErrors}
          requiredMap={getRequired(allFields)}
          fields={allFields}
          answers={fieldAnswers}
          adp
          isSignatureUpload
          forQuestionMarkHelp
        />
        {/* Notes */}
        <div>
          <Collapsible
            adp
            title="Note:"
            openOnMount={false}
            collapsibleHeight="0"
          >
            {notes?.length !== 0 && (
              <div style={{ height: 'auto' }}>
                {notes?.map((ele, i) => <p>{`(${i + 1}) ${ele}`}</p>)}
              </div>
            )}
          </Collapsible>
        </div>
        {/* Required Attachments */}
        {reqAttach?.length !== 0 && (
          <div>
            <Collapsible
              adp
              title="Required Attachments:"
              openOnMount={false}
              collapsibleHeight="0"
            >
                <div style={{ height: 'auto' }}>
                  {reqAttach?.map((ele) => {
                    const attachmentName = typeof ele === 'object' ? ele.attachmentName : ele;
                    return (
                      <ReqAttachments
                        {...staticFields[0]}
                        handleAnswerChanged={(a, b) => handleAnswerChanged(
                          'req_attachments', a, `${attachmentName}_${b}`
                        )}
                        attachments={state.answers?.req_attachments?.[`${typeof ele === 'object'
                          ? ele.attachmentName
                          : ele}_attachments`
                        ]}
                        showFieldErrors={state.formErrors}
                        entityName="adp"
                        getLoadingStatus={getLoadingStatus}
                        handleAutoUploadAttachments={handleUploadAttachments}
                        handleRemove={handleRemoveAttachments}
                        handleAttachmentFailedAlert={getErrorAlert}
                        adpAttachments
                        attachmentName={attachmentName}
                        dateDetails={ele}
                        adpAnswers={state.answers}
                        handleDateChange={(a, b) => handleAnswerChanged(
                          'req_attachments_dates', a, `${attachmentName}_${b}`
                        )}
                        handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
                      />
                    );
                  })}
                </div>
            </Collapsible>
          </div>
        )}
        {/* Static Default Fields - Attachments, Profile and Signature */}
        <div>
          <CustomFields
            fields={reqAttach?.length > 0 ? staticFields.filter(field => field.title !== 'Attachments'): staticFields}
            answers={state.answers}
            showFormErrors={state.formErrors}
            requiredMap={getRequired(staticFields)}
            isSignatureUpload
            entityName="adp"
            getLoadingStatus={getLoadingStatus}
            handleAutoUploadAttachments={handleUploadAttachments}
            handleAttachmentFailedAlert={getErrorAlert}
            handleAnswerChanged={(a, b) => handleAnswerChanged('answers', a, b)}
            handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
            handleRemove={handleRemoveAttachments}
            adpAttachments
            isCrop={staticFields?.filter(s => s.isCrop === true)}
            adp
            forQuestionMarkHelp
          />
        </div>
      </div>
      <div
        className={styles.submitButton}
      >
        <p className={styles.errorMessage}>
          {state.dateError}
        </p>
        <div style={{ display: 'flex', gap: '16px' }}>
          <Button
            action="primary"
            className={styles.marginRight}
            onClick={() => (handelSubmit(true))}
            translationID="inspections.new.finishDraft"
            defaultText={translation['inspections.new.finishDraft']}
            disabled={load}
          />
          <Button
            action="secondary"
            onClick={() => (handelSubmit(false))}
            translationID="adp.submit"
            defaultText={translation.quizSubmit}
            disabled={load}
          />
        </div>
      </div>
      {alert && <SaveAlert alert={alert} setAlert={setAlert} handelSubmit={() => handelSubmit(true)} />}
    </div>
  );
};

export default AdpDriverPublicForm;
